import { Box, Button, Card, Icon, InlineStack } from "@shopify/polaris";
import {ChevronDownIcon,ChevronUpIcon} from "@shopify/polaris-icons";
import React, { useEffect,useState } from "react";
import './index.css'
const Item = ({ 
  item ,
  isClock,
  // handleOpenModal,
  handleFeed,
  setReminderModal,
  handleDowngradeReminde,
  shopifyLevel,
  featureStep,
  setFeatureStep
}) => {
  
  const trimTrailingZeros = (value) => {
    if (typeof value !== "string") return value;

    // 先去掉小数点右侧无用的 0
    value = value.replace(/\.0+$/, "").replace(/(\.\d*?[1-9])0+$/, "$1");

    return value;
  };
  const PriceFun = () => {
    // 价格转换
    let money = item.money || 0;
    let oldMoney = item.money;
    if (item.is_yearly) {
      money = (item.money / 12).toFixed(2);
    }
    if (item.discount > 0) {
      money = (money * item.discount).toFixed(2);
    }
    if (item.is_yearly) {
      oldMoney = (oldMoney).toFixed(2);
    }

    let text = (
      <Box>
        <InlineStack blockAlign="baseline" gap={200}>
          <Box className="plan_item_price">${trimTrailingZeros(money)}</Box>
          {(item.id !== 0 && item.discount <1) ? (
            <Box className="plan_item_old_price plan_item_price_line">${oldMoney}</Box>
          ):''}
          <Box className="plan_item_price_time">
            {item.id === 4 ? <Box style={{position:'relative'}}> <span
                                className="subscript_section_discount_price"
                                style={{
                                  position: "absolute",
                                  left: 0,
                                  width: "100px",
                                  top: "-20px",
                                  color: !shopifyLevel() && "#182FF9",
                                }}
                              >
                                <strong>No trial period</strong>
                              </span></Box>:''}
            <Box>USD/month</Box>
            {/* <Box></Box> */}
          </Box>
        </InlineStack>
      </Box>
    );
    if (item.is_yearly) {
        text = (
            <Box>
              <InlineStack blockAlign="baseline" gap={200}>
                <Box className="plan_item_price">${trimTrailingZeros(money)}</Box>
                <span className="plan_item_price_time">USD/month</span>
                {/* {(item.id !== 0 ) ? (
                  <Box className="plan_item_old_price"><span>${trimTrailingZeros(money)}</span>/month</Box>
                ):''} */}
                {/* <Box className="plan_item_price_time">
                  <Box>USD/</Box>
                  <Box>month</Box>
                </Box> */}
              </InlineStack>
            </Box>
          );
    }
    return text;
  };
  const ButtonFun = () => {
    let variant = '';
    if (item.button.includes('Select') || item.button.includes('Start') ) {
      variant = 'primary'
    }
    let text = (
      <Box className="plan_item_btn">
        {item.button !== 'Downgrade' ? <Button onClick={()=>{
          if (item.is_zt) {
            setReminderModal(true)
          }else {
            handleDowngradeReminde(item.id)
            // handleMageUpgrade(item.id)
          }
        }} loading={item.loading} disabled={item.disabled} variant={variant}>
          {item.button}
        </Button>:<Box  onClick={()=>{
           if (item.is_zt) {
             setReminderModal(true)
            return
           }
          if (item.id === 0) {
            handleFeed()
          }else {
            handleDowngradeReminde(item.id)
          }
        }}><Button  loading={item.loading} disabled={item.disabled}>{item.button}</Button></Box>}
      </Box>
    );
    if (item?.is_zt) {
      text = (
        <Box className={item?.is_zt ? "plan_item_btn plan_item_btn_disabled" : "plan_item_btn"}>
          <Button onClick={()=>{  
           setReminderModal(true)
          }} loading={item.loading} variant={variant}>
            {item.button}
          </Button>
        </Box>
      );
    }
    return text;
  };
  // 闹钟组件
  const TimerDisplay = React.memo(({ hours, minutes, seconds }) => (
    <div className="sub_paid_time_detail_list sub_paid_time_detail_lists">
      <span className="sub_paid_time_detail_item">{hours}</span>
      <strong>:</strong>
      <span className="sub_paid_time_detail_item">{minutes}</span>
      <strong>:</strong>
      <span className="sub_paid_time_detail_item">{seconds}</span>
    </div>
  ));
  // 闹钟倒计时
  const useCountdown = (targetTimestamp) => {
    const [timeLeft, setTimeLeft] = useState(() => ({
      hours: '00',
      minutes: '00',
      seconds: '00',
      total: 0,
    }));
  
    useEffect(() => {
      if (!targetTimestamp) return;
  
      const calculateTime = () => {
        const now = Date.now();
        const total = Math.max(Math.floor((targetTimestamp * 1000 - now) / 1000), 0);
        
        if (total <= 0) {
          return { total: 0, hours: '00', minutes: '00', seconds: '00' };
        }
  
        const hours = Math.floor(total / 3600).toString().padStart(2, '0');
        const minutes = Math.floor((total % 3600) / 60).toString().padStart(2, '0');
        const seconds = (total % 60).toString().padStart(2, '0');
  
        return { total, hours, minutes, seconds };
      };
  
      setTimeLeft(calculateTime());
      
      const timer = setInterval(() => {
        setTimeLeft(prev => {
          const newTime = calculateTime();
          return newTime.total === prev.total ? prev : newTime;
        });
      }, 1000);
  
      return () => clearInterval(timer);
    }, [targetTimestamp]);
  
    return timeLeft;
  };
  
  const DiscountTimer = ({ discountTime }) => {
    const { hours, minutes, seconds } = useCountdown(discountTime);
    return (
      <div className="sub_paid_time_detail" style={{marginBottom:'8px'}}>
        <div className="sub_paid_time_detail_content">
          <div style={{ marginRight: "8px", width: "20px" }}>
            <img style={{ width: "100%" }} src="/sub/vector.png" alt="dropshipman" />
          </div>
          <TimerDisplay hours={hours} minutes={minutes} seconds={seconds} />
        </div>
      </div>
    );
  };
  // 年月月份倒计时展示
  const isClockMonthShow = ()=>{
    let isShow = false;
    if (isClock.month_array.length > 0 ) {
      if (isClock.month_array.includes(1) && isClock.month_array.slice(isClock.month_array.length-1,isClock.month_array.length)[0] !==1) {
        isShow = true;
      }
    }
    
    return isShow;
  }
  const isClockYearShow = ()=>{
    let isShow = false;
    if (isClock.year_array.length > 0 ) {
      if (isClock.year_array.includes(1) && isClock.year_array.slice(isClock.year_array.length-1,isClock.year_array.length)[0] !==1) {
        isShow = true;
      }
    }
    
    return isShow;
  }
  
  const ViewAll = () => {
    const stepKey = `step${item.id}`;
    const isExpanded = featureStep[stepKey] === item.id;
  
    const handleToggle = () => {
      setFeatureStep((prev) => ({
        ...prev,
        [stepKey]: isExpanded ? 0 : item.id,
      }));
    };
  
    return (
      <Box>
        {isExpanded && (
          <Box className="plan_item_dsc">
            <ul style={{ marginBottom: 0 }}>
              {item.dscList.map((desc, k) => (
                <li key={k}>
                  <span>.</span>
                  {desc.p}
                </li>
              ))}
            </ul>
          </Box>
        )}
        <Box style={{ marginTop: "8px", display: "flex", justifyContent: "center" }}>
          <Button variant="tertiary" onClick={handleToggle}>
            <InlineStack blockAlign="center" gap={100}>
              <span>View all features</span>
              <Icon
                source={isExpanded ? ChevronUpIcon : ChevronDownIcon}
                tone="base"
              />
            </InlineStack>
          </Button>
        </Box>
      </Box>
    );
  };
  
  return (
    <Box
      className={
        ((item.bill_level !== 2 && item.bill_level !== 5) && item.id === 2)
          ? "plan_item_box plan_item_box_recommend"
          : "plan_item_box"
      }
    >
      {((item.bill_level !== 2 && item.bill_level !== 5) && item.id === 2) ? (
        <Box className="plan_item_recommend">Recommend</Box>
      ) : (item.bill_level === 2 || item.bill_level === 5) ? '' : (
        <Box className="plan_item_recommend" style={{ opacity: 0 }}>
          Recommend
        </Box>
      )}
      <Card>
        <InlineStack blockAlign="center" gap={100}>
          <Box className="plan_item_name">{item.name} </Box>
          <img style={{ verticalAlign: "bottom",fontSize:"20px" }} src={item.title_icon} alt='logo'/>
        </InlineStack>
        <Box className="plan_item_name_dsc">{item.dsc}</Box>
        <Box style={{ margin: "5px 0" }}>
          <PriceFun />
        </Box>
        {(isClockMonthShow() && item.is_yearly === 0) ? <Box>
        {(item.id === 1 || item.id === 2) && item.discount < 1 ? <div className="throw_line" style={{marginBottom:'4px'}}>
          <span className="subscript_section_discount_price">
            {parseFloat((1 - item.discount) * 100).toFixed(
              0
            )}
            % off{" "}
            <strong>
              <svg
                style={{
                  fontSize: "20px",
                  verticalAlign: "middle",
                }}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="20" height="20" fill="white" />
                <path
                  d="M8.47134 12.8168L11.8048 9.69179C11.9298 9.5746 12 9.41566 12 9.24992C12 9.08419 11.9298 8.92524 11.8048 8.80805C11.6798 8.69086 11.5102 8.62502 11.3334 8.62502C11.1566 8.62502 10.9871 8.69086 10.8621 8.80805L8.66668 10.8662V3.62499C8.66668 3.45923 8.59644 3.30026 8.47142 3.18306C8.34639 3.06585 8.17682 3 8 3C7.82318 3 7.65361 3.06585 7.52858 3.18306C7.40356 3.30026 7.33332 3.45923 7.33332 3.62499V10.8662L5.13793 8.80805C5.01292 8.69086 4.84337 8.62502 4.66658 8.62502C4.48979 8.62502 4.32025 8.69086 4.19524 8.80805C4.07023 8.92524 4 9.08419 4 9.24992C4 9.41566 4.07023 9.5746 4.19524 9.69179L7.52865 12.8168C7.59051 12.8748 7.66399 12.9209 7.74486 12.9524C7.82574 12.9838 7.91244 13 8 13C8.08756 13 8.17426 12.9838 8.25514 12.9524C8.33601 12.9209 8.40948 12.8748 8.47134 12.8168Z"
                  fill="#F5520C"
                />
              </svg>
            </strong>
          </span>
          <p className="subscript_section_date">
              <span>{"THE FIRST MONTH"}</span>
          </p>
        </div>: <div className="throw_line" style={{height:'22px',marginBottom:'4px'}}>
        </div>}
        </Box>:''}
        {/* 仅高级套餐有折扣不展示闹钟 */}
        {(isClockMonthShow() &&  item.is_yearly === 0) && shopifyLevel() ? <Box>
          {((item.id !==0) && item.is_discount_pop) ? <Box className='sub_top_time'>
          <DiscountTimer discountTime={item.discount_time} />
          </Box>:<Box style={{opacity:0}} className='sub_top_time'>
          <DiscountTimer discountTime={item.discount_time} />
          </Box>}
        </Box> :""}
        {(isClockYearShow() &&  item.is_yearly === 1) && shopifyLevel() ? <Box>
          {((item.id !==0) && item.is_discount_pop) ? <Box className='sub_top_time'>
          <DiscountTimer discountTime={item.discount_time} />
          </Box>:<Box style={{opacity:0}}  className='sub_top_time'>
          <DiscountTimer discountTime={item.discount_time} />
          </Box>}
        </Box> :""}
        <Box>
          <ButtonFun />
        </Box>
        {(item.bill_level !== 2 && item.bill_level !== 5) && <Box className='new_sub_more_view' style={{marginBottom:'-28px'}}>
        {/* {item.first_purchase && item.is_yearly === 0 && (
          <Box>
            <Box
              className={
                (item?.first_purchase && item.id === 2)
                  ? "first_purchase_setting "
                  : "first_purchase_setting first_purchase_setting_line"
              }
            >
              <InlineStack blockAlign="center" align="center">
                {item.id === 2 ? (
                  <img width={30} src="/sub/big_gift.png" alt="dropshipman" />
                ) : (
                  ""
                )}
                <span className="first_purchase_gift" onClick={()=>{
                  if (item.id === 2) {
                    handleOpenModal()
                  }
                }}>
                  <strong>$200</strong> extra benefits
                </span>
              </InlineStack>
            </Box>
          </Box>
        )} */}
        {item.common.length > 0 ? (
          <Box className="plan_item_common">
            <Box className="plan_item_common_title">Core benefits</Box>
            <ul>
              {item.common.map((it, k) => (
                <li key={k}>
                  <span>.</span>
                  {it}
                </li>
              ))}
            </ul>
          </Box>
        ) : (
          ""
        )}
        {item.id === 0 ? <Box className="plan_item_dsc" >
          <ul style={{marginBottom:0}}>
            {item.dscList.map((desc, k) => (
              <li key={k}>
                <span>.</span>
                {desc.p}
              </li>
            ))}
          </ul>
        </Box>:<ViewAll />}
        </Box>}
      </Card>
    </Box>
  );
};

export default Item;
